// material ui
import { Container, type ContainerProps } from '@mui/material';

// components
import { useContainerLayout } from '@/contexts/ContainerLayoutContext';

/**
 * Drop-in replacement for MUI's `Container` used as the outermost wrapper
 * on most routes. Defaults to `maxWidth="xl"`, but renders full width
 * (`maxWidth={false}`) when the user has toggled full width on via
 * `SettingsMenu` in the `AppBar`. Containers with an explicit,
 * narrower `maxWidth` (e.g. forms/dialogs using `md`/`sm`) are left as-is.
 */
export default function PageContainer({
  maxWidth = 'xl',
  ...props
}: ContainerProps) {
  const { fullWidth } = useContainerLayout();

  const effectiveMaxWidth = fullWidth && maxWidth === 'xl' ? false : maxWidth;

  return <Container maxWidth={effectiveMaxWidth} sx={{ py: 2 }} {...props} />;
}
